export default __webpack_public_path__ + "static/media/datte_slider.9f3e9e15.webp";